export default "__VITE_ASSET__BBgeWzF5__"